const mContentEditor = {
  mContentEditor: {
    alerts: {
      setNodoActivoTarea: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Las tarea se guardó exitosamente. En breve será revisada.'
      }
    }
  }
}

export default mContentEditor
